module.exports = "../fonts/vendor/vendor/typeface-inter/Inter Web/Inter-BlackItalic.woff?4bd1bed67df41b83810b2a792e054a71";